import { UseFormRegister } from 'react-hook-form';
import { FormControl, FormLabel, Input } from '@cdl/heartbeat-react';
import { FormValues } from '../../../types/annotation-task-detail.type';

type Props = {
  register: UseFormRegister<FormValues>;
  name: string;
};

export const InputForm: React.FC<Props> = ({ name, register }) => {
  return (
    <FormControl pb='m'>
      <FormLabel htmlFor={name}>
        {name.charAt(0).toUpperCase() + name.slice(1)}*
      </FormLabel>
      <Input
        id={name}
        placeholder={`Enter a ${name}`}
        {...register(name, {
          required: 'This is required',
        })}
      />
    </FormControl>
  );
};
